import React, { Component } from "react";
import { connect } from "react-redux";

import People from "@material-ui/icons/People";
import InputAdornment from "@material-ui/core/InputAdornment";
import { withRouter, Link } from "react-router-dom";
import { Alert, Loader } from "rsuite";
import { customAlert } from "../Alert/alert.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import Button from "../LogButton/Button";
import CustomInput from "../CustomInput/CustomInput";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";

import "./sign-in.styles.scss";
import API from "../../E2E/axios.util";

import { SetAuthedUser } from "../../Redux/User/user.action";

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      password: "",
      isDisabled: false,
      ShowPassword: false,
    };
    this.location = {
      pathname: "/Dashboard",
      state: { fromLogin: true },
    };
  }

  _handleStorage = async () => {
    const { emailId } = this.state;
    await sessionStorage.setItem("EmailID", JSON.stringify(emailId));
    this._handleStateChange();
  };

  _handleStateChange = async () => {
    this.props.SetAuthedUser();
    let userId = await sessionStorage.getItem("EmailID");
    if (userId) {
      customAlert("success", "Login Success");
      this.props.history.replace(this.location);
      this.setState({
        isDisabled: !this.state.isDisabled,
      });
    } else {
      Alert.info("Waiting For Approval");
    }
  };

  //handle text Change
  _handleChnage = (event) => {
    const { value, name } = event.target;
    this.setState({ [name]: value });
  };
  //handle Form Submission
  _handleSubmit = async (event) => {
    //dataDestructure
    event.preventDefault();
    this.setState({ isDisabled: !this.state.isDisabled });
    const userData = {
      emailId: this.state.emailId,
      password: this.state.password,
    };
    //API CALL
    await API.post("/login", userData)
      .then((User) => {
        console.log(User);
        this._handleStorage();
      })
      .catch((err) => {
        console.log(err);
        this.setState(
          {
            isDisabled: !this.state.isDisabled,
          },
          () =>
            this.setState({
              emailId: "",
              password: "",
            })
        );
        customAlert("error", "Login Failed");
      });
  };
  //render JSX
  render() {
    return (
      <div className="sign-in">
        <span className="subTitle">LOGIN Your Account</span>
        <form
          onSubmit={this._handleSubmit}
          style={{
            width: "100%",
            alignSelf: "center",
            justifyContent: "center",
          }}
        >
          <GridContainer ms={12} lg={12} xs={12}>
            <GridItem>
              <CustomInput
                name="emailId"
                labelText="Email"
                id="material"
                onChange={this._handleChnage}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <People className="title" style={{ marginBottom: 5 }} />
                    </InputAdornment>
                  ),
                }}
                type="email"
                required
                white={true}
              />
            </GridItem>
            <GridItem>
              <CustomInput
                name="password"
                labelText="Password"
                id="primary"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <FontAwesomeIcon
                        icon={!this.state.ShowPassword ? faEye : faEyeSlash}
                        style={{ cursor: "pointer", marginBottom: 5 }}
                        onClick={() =>
                          this.setState({
                            ShowPassword: !this.state.ShowPassword,
                          })
                        }
                      />
                    </InputAdornment>
                  ),
                }}
                onChange={this._handleChnage}
                type={!this.state.ShowPassword ? "password" : "text"}
                required
                white={true}
              />
            </GridItem>
            <GridItem>
              <p
                style={{
                  fontFamily: "Montserrat",
                  color: "white",
                  margin: "20px 20px",
                  fontWeight: "600",
                }}
              >
                Don't Have An Account??
                <Link style={{ color: "yellow" }} to="/Registration">
                  {" "}
                  Click Here
                </Link>
              </p>
            </GridItem>
            <div className="buttons">
              {this.state.isDisabled ? (
                <Loader />
              ) : (
                <Button
                  type="submit"
                  disabled={this.state.password.length < 8 ? true : false}
                >
                  <FontAwesomeIcon icon={faUser} style={{ marginRight: 10 }} />
                  Login
                </Button>
              )}
            </div>
          </GridContainer>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  SetAuthedUser: () => dispatch(SetAuthedUser()),
});

export default withRouter(connect(null, mapDispatchToProps)(SignIn));
